<template>
    <header class="header">
      <div class="logo">
        <img src="@/assets/images/logo_header.png" alt="Logo" />
      </div>
      <div class="header_icons_container">
        <div @click="redeemClicked" class="clickable">
          <template v-if="isMobile">
            <img 
              :src="props.navigationPosition == 1 ? require('@/assets/images/canjear_icon_on.png') : require('@/assets/images/canjear_icon.png')"
              alt="Canjear"
              class="header_icon"/>
          </template>
          <template v-else>
            <span class="header_text" :class="props.navigationPosition == 1 ? 'header_text_green' : ''">Reservas</span>
          </template>
        </div>
        <div @click="paymentsClicked" class="clickable" v-if="props.userType === 'main'">
          <template v-if="isMobile">
            <img 
              :src="props.navigationPosition == 2 ? require('@/assets/images/payments_icon_on.png') : require('@/assets/images/payments_icon.png')"
              alt="Pagos"
              class="header_icon"/>
          </template>
          <template v-else>
            <span class="header_text" :class="props.navigationPosition == 2 ? 'header_text_green' : ''">Facturación</span>
          </template>
        </div>

        <img 
          @click="profileClicked"
          :src="props.navigationPosition == 3 ? require('@/assets/images/profile_icon_on.png') : require('@/assets/images/profile_icon.png')"
          alt="Perfil"
          class="header_icon"
          v-if="props.userType === 'main'"/>
        <img @click="logoutClicked" src="@/assets/images/logout_icon.png" alt="Cerrar sesión" class="header_icon logout_icon"/>
      </div>
    </header>
    <TwoButtonPopup 
      :title="twoButtonTitle"
      :message="twoButtonMessage"
      :acceptButton="twoButtonAcceptButton"
      @acceptCallback="logoutConfirmed"
      :cancelButton="twoButtonCancelButton"
      @cancelCallback="twoButtonCancelCallback"
      />
  </template>
  
  <script setup>
  import { ref, defineProps, onMounted, onBeforeUnmount } from "vue";
  import { useRouter } from 'vue-router';
  import TwoButtonPopup from './TwoButtonPopup.vue';
  
  const props = defineProps({
    navigationPosition: Number, // 0 None, 1 Redeem, 2 Payments, 3 Profile, 4 Logout
    userType: String // "main" or "optional"
  });

  const router = useRouter();
 
  const twoButtonTitle = ref("");
  const twoButtonMessage = ref("");
  const twoButtonAcceptButton = ref("");
  const twoButtonCancelButton = ref("");
  const loading = ref(false);

  const logoutClicked = () => {
    twoButtonTitle.value = "Cerrar sesión";
    twoButtonMessage.value = "¿Estás seguro de que deseas cerrar sesión?";
    twoButtonAcceptButton.value = "Cerrar sesión";
    twoButtonCancelButton.value = "Cancelar";
  };

  const redeemClicked = () => {
    router.push('/redeem');
  };

  const paymentsClicked = () => {
    router.push('/payments');
  };

  const profileClicked = () => {
    router.push('/profile');
  };

  const logoutConfirmed = async () => {
    twoButtonTitle.value = "";
    loading.value = true;
    try {
      const response = await fetch(process.env.VUE_APP_API_URL+"api/dashboard/auth/logout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "vdas": process.env.VUE_APP_API_VDAS,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
          "Authorization": "Bearer " + localStorage.getItem('token'),
        },
        body: JSON.stringify({
          "user_id": localStorage.getItem('user_id')
        }),
      });

      await response.json();

    } catch (exception) {
      // do nothing
    } finally {
      loading.value = false;
      localStorage.removeItem('user_id');
      localStorage.removeItem('token');
      router.push('/');
    }
  };

  const twoButtonCancelCallback = () => {
    twoButtonTitle.value = "";
    twoButtonMessage.value = "";
  };

  const isMobile = ref(window.innerWidth <= 768)

  function handleResize() {
    isMobile.value = window.innerWidth <= 768
  }

  onMounted(() => {
    window.addEventListener('resize', handleResize)
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize)
  });

</script>
  
  <style scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 40px 24px 40px;
    background-color: var(--gray);
    color: white;
    margin: 0;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 90px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    transition: var(--transition);
    box-sizing: border-box;
  }
  
  .logo {
    display: flex;
    align-items: center;
    cursor: pointer;
    width: 600px;
    max-width: 50%;
    margin-right: 30px;
    transition: var(--transition);
}

  .logo:hover {
    opacity: 0.9;
  }
  
  .logo img {
    width: 100%;
    max-width: 400px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .header_icon {
    height: 32px;
    display: flex;
    cursor: pointer;
    align-items: center;
    transition: var(--transition);
    filter: brightness(1);
  }

  .header_icon:hover {
    filter: brightness(1.2);
    transform: translateY(-2px);
  }

  .header_icons_container {
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 32px;
  }

  .clickable {
    cursor: pointer;
    position: relative;
    transition: var(--transition);
  }

  .clickable:hover {
    transform: translateY(-2px);
  }

  .header_text {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.5px;
    transition: var(--transition);
    position: relative;
    padding-bottom: 4px;
  }

  .header_text:hover {
    color: rgba(255, 255, 255, 0.9);
  }

  .header_text_green {
    color: var(--primary-color);
  }

  .header_text_green::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    background-color: var(--primary-color);
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    .header {
      padding: 16px 20px;
      height: 70px;
    }

    .header_icons_container {
      gap: 16px;
    }

    .header_icon {
      height: 28px;
    }

    .header_text {
      font-size: 14px;
    }

    .logo img {
      max-width: 250px;
    }

    .logout_icon {
      margin-right: 0;
    }
  }

  @media (max-width: 450px) {
    .header {
      flex-direction: column;
      height: auto;
      padding: 12px 16px;
      gap: 12px;
      align-items: flex-start;
    }

    .logo {
      width: 100%;
      max-width: 100%;
      margin-right: 0;
      justify-content: center;
    }

    .logo img {
      max-width: 200px;
    }

    .header_icons_container {
      width: 100%;
      justify-content: center;
      gap: 20px;
    }

    .header_icon {
      height: 26px;
    }

    .header_text {
      font-size: 13px;
    }
  }

  .logout_icon {
    margin-right: 0;
  }

</style>
  